<script>
	import { getContext } from 'svelte';

	const { data, xScale, yScale, custom, zGet} = getContext('LayerCake');

	export let hovered = null;
	export let selected = null;
	export let width;
	
	let coords = $custom.coords;
	let idKey = $custom.idKey;
	let labelKey = $custom.labelKey;
	// let colorHover = $custom.colorHover ? $custom.colorHover : 'orange';
	// let colorSelect = $custom.colorSelect ? $custom.colorSelect : '#206095';

	// let say = $coords.map(d => d.at(-1).y)[0]

	console.log(width)
	console.log(window.innerWidth-5-$data[0][0][labelKey].length*9)

	function similarY(x, i) {

		x = x + i*0.111

		let azza = $coords.map( d => $yScale(d[d.length -1].y) - x )
		let azzaorder = azza.sort((a, b) => { return Math.abs(a) - Math.abs(b) } )

		let finalPositions = $coords.map( d => $yScale(d[d.length -1].y))

		finalPositions.forEach(function(e,ind) {finalPositions[ind] += ind*0.111})

		let finalPositionsExcludingCurrent = finalPositions.filter((el, index) => {return (index != i)})

		if (Math.min(...finalPositionsExcludingCurrent) < x && Math.max(...finalPositionsExcludingCurrent) > x) {return x}

		else if (Math.min(...finalPositionsExcludingCurrent) - x < 15 && Math.min(...finalPositionsExcludingCurrent) - x > 0) {return x - 20}

		else if (x - Math.max(...finalPositionsExcludingCurrent) < 15 && x - Math.max(...finalPositionsExcludingCurrent) > 0) {return x + 20} 

		else {return x}

	}
	function capi(s) {
		return s.charAt(0).toUpperCase() + s.slice(1);
	}

</script>

{#if $coords}
<defs>
	<filter x="0" y="0" width="1" height="1" id="bgfillhov">
		<feFlood flood-color="rgba(255,255,255,0.8)" result="bg" />
		<feMerge>
			<feMergeNode in="bg"/>
			<feMergeNode in="SourceGraphic"/>
		</feMerge>
	</filter>
	<filter x="0" y="0" width="1" height="1" id="bgfill">
		<feFlood flood-color="rgba(255,255,255,0.8)" result="bg" />
		<feMerge>
			<feMergeNode in="bg"/>
			<feMergeNode in="SourceGraphic"/>
		</feMerge>
	</filter>
</defs>

<g class="label-group">
	{#if $coords[0] && $coords[0][0] && $coords[0][0].x}
		{#each $coords as d, i}
			<!-- {#if [hovered, selected].includes($data[i][0][idKey])} -->
			{#if width/2 <= (window.innerWidth-5-$data[i][0][labelKey].length*9)}

			<text
				class="label"
				transform="translate(2,3)"
				filter="url(#bgfill)"
				fill={i == 1 ? "#333" : $zGet($data[i][0])}
				x={$xScale(d[d.length - 1].x)+10}
				y={ similarY($yScale(d[d.length - 1].y), i) }>
				{capi($data[i][0][labelKey])}
			</text>

			{:else}

			<text
				class="label"
				transform="translate(2,-8)"
				filter="url(#bgfill)"
				fill={i == 1 ? "#333" : $zGet($data[i][0])}
				x={$xScale(d[d.length - 1].x)+10}
				y={ similarY($yScale(d[d.length - 1].y), i) }>
				{capi($data[i][0][labelKey].substring(0, $data[i][0][labelKey].indexOf(" ", Math.round($data[i][0][labelKey].length/2-2))))}
			</text>

			<text
				class="label"
				transform="translate(2,8)"
				filter="url(#bgfill)"
				fill={i == 1 ? "#333" : $zGet($data[i][0])}
				x={$xScale(d[d.length - 1].x)+10}
				y={ similarY($yScale(d[d.length - 1].y), i) }>
				{capi($data[i][0][labelKey].substring($data[i][0][labelKey].indexOf(" ", Math.round($data[i][0][labelKey].length/2-2))))}
			</text>

			{/if}

		{/each}
	{/if}
</g>


<g class="hover-label-group">
	{#if $coords[0] && $coords[0][0] && $coords[0][0].x}
		{#each $coords as d, i}
			{#each d as dd}	
				{#if hovered == dd}
					<text
						class="hover-label"
						filter="url(#bgfillhov)"
						fill={i == 1 ? "#333" : $zGet($data[i][0])}
						x={$xScale(dd.x)-12}
						y={$yScale(dd.y)-15}>
							{dd.y}
					</text>
				{/if}
			{/each}
		{/each}
	{/if}
</g>


{/if}

<style>
	.hover-label {
		font-weight: 800;
	}
	.label {
	}
</style>